module.exports = __webpack_public_path__ + "img/file_img.9f82d595.svg";